import MultiColumnComponent from '../../../MultiColumn';
import { useListPresentationContextData } from '../../context/ListPresentationContext';

export default function MultiColumnRenderer() {
  const data = useListPresentationContextData();
  const { iterableList, listPresentationConfig, cardFrameConfig } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const { oneGridCellGeometry, sectionColors } = getConfigsAndUtils().generalValues;

  return iterableList?.map((columnData, index) =>
    columnData?.isVisible ? (
      <MultiColumnComponent
        key={index}
        index={index}
        columnData={columnData}
        oneGridCellGeometry={oneGridCellGeometry}
        listPresentationConfig={listPresentationConfig}
        cardFrameConfig={cardFrameConfig}
        sectionColors={sectionColors}
      />
    ) : null
  );
}
